
export function getApiBaseUrl() {
  const env = process.env.REACT_APP_API_URL;
  if (env != null && String(env).trim() !== '') {
    return String(env).trim().replace(/\/$/, '');
  }
  return 'https://api.squareandangle.pranatigroup.in';
}

export function uploadUrl(filename) {
  if (filename == null || filename === '') return '';
  let name = String(filename).trim();
  if (!name) return '';
  name = name.replace(/\\/g, '/');
  if (/^https?:\/\//i.test(name)) return name;
  name = name.replace(/^\/?uploads\//i, '');
  return `${getApiBaseUrl()}/uploads/${name}`;
}
